if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.end = new Date(this.dataset.end).getTime();
      this.days = this.querySelector('[data-days]');
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const distance = this.end - Date.now();
      if (isNaN(this.end) || distance <= 0) {
        this.days.textContent = '00';
        this.hours.textContent = '00';
        this.minutes.textContent = '00';
        this.seconds.textContent = '00';
        clearInterval(this.interval);
        return;
      }
      const d = Math.floor(distance / 86400000);
      const h = Math.floor((distance % 86400000) / 3600000);
      const m = Math.floor((distance % 3600000) / 60000);
      const s = Math.floor((distance % 60000) / 1000);
      this.days.textContent = String(d).padStart(2, '0');
      this.hours.textContent = String(h).padStart(2, '0');
      this.minutes.textContent = String(m).padStart(2, '0');
      this.seconds.textContent = String(s).padStart(2, '0');
    }
  }
  customElements.define('countdown-timer', CountdownTimer);
}
